
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|1540|2878|9262)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
